import { SvgIcon } from '@mui/material';

function SearchJobIcon({ fill }) {
  return (
    <SvgIcon width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d={`M16.9248 15.1801L12.9131 11.1684C13.8106 10.0828 14.3506 8.69117 
        14.3506 7.17578C14.3506 3.71553 11.5354 0.900391 8.0752 0.900391C4.61495 
        0.900391 1.7998 3.71553 1.7998 7.17578C1.7998 10.636 4.61495 13.4512 8.0752 
        13.4512C9.59058 13.4512 10.9822 12.9112 12.0679 12.0137L16.0795 16.0253C16.3129 
        16.2587 16.6914 16.2588 16.9248 16.0253C17.1581 15.792 17.1582 15.4136 16.9248 
        15.1801ZM8.0752 12.2559C5.27404 12.2559 2.99512 9.97694 2.99512 7.17578C2.99512 
        4.37463 5.27404 2.0957 8.0752 2.0957C10.8764 2.0957 13.1553 4.37463 13.1553 
        7.17578C13.1553 9.97694 10.8764 12.2559 8.0752 12.2559Z`}
        fill="white"
      />
      <path
        d={`M16.9248 15.1801L12.9131 11.1684C13.8106 10.0828 14.3506 8.69117 14.3506 
        7.17578C14.3506 3.71553 11.5354 0.900391 8.0752 0.900391C4.61495 0.900391 
        1.7998 3.71553 1.7998 7.17578C1.7998 10.636 4.61495 13.4512 8.0752 
        13.4512C9.59058 13.4512 10.9822 12.9112 12.0679 12.0137L16.0795 
        16.0253C16.3129 16.2587 16.6914 16.2588 16.9248 16.0253C17.1581 
        15.792 17.1582 15.4136 16.9248 15.1801ZM8.0752 12.2559C5.27404 
        12.2559 2.99512 9.97694 2.99512 7.17578C2.99512 4.37463 5.27404 
        2.0957 8.0752 2.0957C10.8764 2.0957 13.1553 4.37463 13.1553 7.17578C13.1553 
        9.97694 10.8764 12.2559 8.0752 12.2559Z`}
        fill={fill}
        fillOpacity="0.3"
      />
    </SvgIcon>
  );
}

export default SearchJobIcon;
